import React from "react";
import { Trans, useTranslation } from "react-i18next";

const Home: React.FC = () => {
  const { i18n } = useTranslation();

  const switchLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div>
      <p>
        <Trans>home.description</Trans>
      </p>
      <h1>
        <Trans>welcome</Trans>
      </h1>
      <button onClick={() => switchLanguage("en")}>English</button>
      <button onClick={() => switchLanguage("sw")}>Swahili</button>
    </div>
  );
};

export default Home;
